import { createPlaceholderRotator } from '../placeholder-rotation.js';

document.addEventListener('DOMContentLoaded', function () {
    const main_ai_start_btn = document.querySelector('#mw-realtime-ai-root');
    if (!main_ai_start_btn) {
        console.error('[Realtime] #mw-realtime-ai-root nicht gefunden');
        return;
    }

    const chatWindow = document.querySelector('.mw-ai-realtime-active-chat-window');
    if (!chatWindow) {
        return;
    }

    const isHistoryEnabled = (window.mwRealtimeAiConfig && false !== window.mwRealtimeAiConfig.history_enabled);

    const disclaimer_dialog = document.querySelector('.mw-realtime-ai-confirm-use');
    const accept_danger_is_okay_btn = document.querySelector('.mw-realtime-risk-okay');
    const did_not_accept_danger_btn = document.querySelector('.mw-realtime-risk-not-okay');
    const dialog = document.querySelector('.mw-ai-realtime-chat-wrapper');
    const faqExamples = document.querySelector('.mw-ai-realtime-faq-examples');

    faqExamples.style.pointerEvents = 'none';

    const all_given_faq_points = document.querySelectorAll('.single-faq-example');

    const CHAT_HISTORY_KEY = 'mw_ai_chat_history_v1';
    const MAX_CHAT_HISTORY = 30;

    const maximize_window_btn = document.querySelector('.mw-ai-max-btn');
    const minimize_window_btn = document.querySelector('.mw-ai-min-btn');
    const minimized_icons_wrapper = document.querySelector('.mw-realtime-minimized-icons-wrapper');

    let dialog_is_maximized = false;
    let dialog_is_minimized = false;

    let isSessionActive = false;
    let messageQueue = []; // Queue für Nachrichten bevor Verbindung steht
    let isConnectionReady = false; // Flag ob DataChannel bereit ist

    if ( maximize_window_btn ) {
        maximize_window_btn.addEventListener( 'click', function() {
            if ( dialog.classList.contains( 'mw-ai-minimized' ) ) {
                dialog.classList.remove( 'mw-ai-minimized' )
            }
            dialog.classList.toggle( 'mw-ai-maximized' );
            dialog_is_maximized = true;
            dialog_is_minimized = false;
        } );
    }

    if ( minimize_window_btn ) {
        minimize_window_btn.addEventListener( 'click', function() {
            if ( dialog.classList.contains( 'mw-ai-maximized' ) ) {
                dialog.classList.remove( 'mw-ai-maximized' )
            }
            dialog.classList.toggle( 'mw-ai-minimized' );
            dialog_is_maximized = false;
            dialog_is_minimized = true;
            dialog.close();
            // Hier nun die Minimized Symbole anzeigen.
            if ( minimized_icons_wrapper.classList.contains('hidden') ) {
                minimized_icons_wrapper.classList.remove('hidden');
            }
        } );
    }

    const USER_TRANSCRIPT_REGEX = /(conversation\.item\.)?input_audio.*transcr/i;
    const ASSISTANT_TEXT_DELTA_TYPES = [
        'response.text.delta',
        'response.audio_transcript.delta',
        'response.output_text.delta',
        'response.output_audio_transcript.delta'
    ];
    const ASSISTANT_TEXT_DONE_TYPES = [
        'response.text.done',
        'response.audio_transcript.done',
        'response.output_text.done',
        'response.output_audio_transcript.done'
    ];

    const isAssistantTextDelta = (evtType = '') => ASSISTANT_TEXT_DELTA_TYPES.includes(evtType);
    const isAssistantTextDone = (evtType = '') => ASSISTANT_TEXT_DONE_TYPES.includes(evtType);
    const isUserTranscriptDelta = (evtType = '') => USER_TRANSCRIPT_REGEX.test(evtType) && evtType.includes('.delta');
    const isUserTranscriptDone = (evtType = '') => USER_TRANSCRIPT_REGEX.test(evtType) && (
        evtType.includes('.done') ||
        evtType.includes('.completed') ||
        evtType.includes('.commit')
    );

    const extractTranscriptText = (evt) => {
        if (!evt) return '';
        if (typeof evt.delta === 'string' && evt.delta.length) return evt.delta;
        if (typeof evt.text === 'string' && evt.text.length) return evt.text;
        if (typeof evt.transcript === 'string' && evt.transcript.length) return evt.transcript;
        const transcriptFromArray = evt?.transcripts?.[0]?.text;
        if (typeof transcriptFromArray === 'string' && transcriptFromArray.length) return transcriptFromArray;
        const contentText = evt?.item?.content?.[0]?.text;
        if (typeof contentText === 'string' && contentText.length) return contentText;
        const outputText = evt?.output?.[0]?.content?.[0]?.text;
        if (typeof outputText === 'string' && outputText.length) return outputText;
        return '';
    };

    const loadChatHistory = () => {
        if (!isHistoryEnabled) return [];
        try {
            const raw = localStorage.getItem(CHAT_HISTORY_KEY);
            if (!raw) return [];
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
            console.warn('[Realtime] Konnte Verlauf nicht laden:', e);
            return [];
        }
    };

    const saveChatHistory = (history) => {
        if (!isHistoryEnabled) return;
        try {
            localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(history));
        } catch (e) {
            console.warn('[Realtime] Konnte Verlauf nicht speichern:', e);
        }
    };
    const persistHistoryMessage = (role, text, linkHref = '', linkLabel = '') => {
        if (!isHistoryEnabled) return;
        if (!text) return;
        const history = loadChatHistory();
        history.push({role, text, linkHref, linkLabel});
        if (history.length > MAX_CHAT_HISTORY) {
            history.splice(0, history.length - MAX_CHAT_HISTORY);
        }
        saveChatHistory(history);

        // Nachricht auch an Backend senden für Statistik
        logMessageToBackend(role, text);
    };

    // Session-ID generieren (UUID v4)
    const generateSessionId = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    const refreshNonce = async () => {
        try {
            const response = await fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/realtime/nonce', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            if (data.nonce) {
                mwRealtimeAiConfig.nonce = data.nonce;
                return true;
            }
            return false;
        } catch (e) {
            return false;
        }
    };

    // Session im Backend starten
    const startSession = async () => {
        if (!sessionId) {
            sessionId = generateSessionId();
        }
        try {
            const response = await fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/realtime/session/start', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                },
                body: JSON.stringify({
                    session_id: sessionId,
                    prompt_id: promptId
                })
            });
            const data = await response.json();
            if (data.security_token) {
                sessionSecurityToken = data.security_token;
                console.log('[Realtime] Session Security Token empfangen');
            }
        } catch (e) {
            console.warn('[Realtime] Konnte Session nicht starten:', e);
        }
    };

    // Nachricht im Backend loggen
    const logMessageToBackend = async (role, content) => {
        if (!sessionId || !content) return;
        try {
            await fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/realtime/session/message', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                },
                body: JSON.stringify({
                    session_id: sessionId,
                    role: role,
                    content: content,
                    type: 'text'
                })
            });
        } catch (e) {
            console.warn('[Realtime] Konnte Nachricht nicht loggen:', e);
        }
    };

    // Session beenden
    const endSession = async () => {
        if (!sessionId) return;
        try {
            await fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/realtime/session/end', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                },
                body: JSON.stringify({
                    session_id: sessionId
                })
            });
        } catch (e) {
            console.warn('[Realtime] Konnte Session nicht beenden:', e);
        }
    };

    accept_danger_is_okay_btn.addEventListener('click', function (e) {
        e.preventDefault();
        sessionStorage.setItem('mw_ai_consent', '1');
        if (!isSessionActive) {
            start_gpt_connect();
            isSessionActive = true;
        }
        disclaimer_dialog.close();
    });

    did_not_accept_danger_btn.addEventListener('click', function (e) {
        e.preventDefault();
        disclaimer_dialog.close();
        dialog.close();
    });

    main_ai_start_btn.addEventListener('click', function () {
        if (dialog) {
            if ( minimized_icons_wrapper && ! minimized_icons_wrapper.classList.contains('hidden') ) {
                 minimized_icons_wrapper.classList.add('hidden');
            }
            open_ai_dialog(dialog);
            // Den Disclaimer nur anzeigen wenn noch nicht bestätigt.
            if ('1' !== sessionStorage.getItem('mw_ai_consent')) {
                disclaimer_dialog.showModal();
            }
            if ('1' === sessionStorage.getItem('mw_ai_consent')) {
                if (!isSessionActive) {
                    start_gpt_connect();
                    isSessionActive = true;
                }
            }
        }
    });

    // Auf FAQ reagieren.
    all_given_faq_points.forEach( function(single_faq) {
        single_faq.addEventListener( 'click', function() {
            sendUserMessage( single_faq.getAttribute('data-prompt') )
        } );
    } )

    // Event Listener für externe Trigger
    document.addEventListener('mw_ai_send_message', function(event) {
        if (event.detail && event.detail.text) {
            // Wenn Verbindung noch nicht bereit, in Queue speichern
            if (!isConnectionReady) {
                messageQueue.push({
                    text: event.detail.text,
                    showInChat: false
                });
            } else {
                // Text wird NICHT im Chat angezeigt, nur als Kontext für KI
                sendUserMessage(event.detail.text, false);
            }
        }
    });

    document.addEventListener('mw_ai_send_message_show', function(event) {
        if (event.detail && event.detail.text) {
            // Wenn Verbindung noch nicht bereit, in Queue speichern
            if (!isConnectionReady) {
                messageQueue.push({
                    text: event.detail.text,
                    showInChat: true
                });
            } else {
                // Text wird NICHT im Chat angezeigt, nur als Kontext für KI
                sendUserMessage(event.detail.text, true);
            }
        }
    });

    let remoteAudioEl = document.querySelector('#mw-ai-realtime-remote-audio');
    if (!remoteAudioEl) {
        return;
    }
    const modal_close_btn = document.querySelector('.mw-ai-close-btn');
    const user_input_field = document.querySelector('#mw-ai-real-time-chat-input');
    if (!user_input_field) {
        return;
    }

    let placeholderRotationConfig = {};
    try {
        placeholderRotationConfig = JSON.parse(user_input_field.getAttribute('data-placeholder-rotation') || '{}');
    } catch (error) {
        console.warn('[Realtime] Ungültige Placeholder-Konfiguration:', error);
    }
    const placeholderRotator = createPlaceholderRotator(user_input_field, placeholderRotationConfig);

    let pcRef = null;
    let micStreamRef = null;
    let callIdRef = null;
    // iOS Safari benötigt Mikrofon-Zugriff direkt bei Verbindungsaufbau
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    // Neue Variablen für Push-to-Record
    let isRecording = false; // Tracking ob aktuell aufgenommen wird
    let wasRecording = false; // Tracking ob Recording gerade gestoppt wurde (für Transkriptions-Events)
    let pendingSubmitAfterTranscription = false; // Auto-Submit nach Transkription, wenn User während Recording auf "Senden" gedrückt hat
    let recordingStartTime = null; // Zeitpunkt des Aufnahmebeginns
    let audioContext = null;
    let analyserNode = null;
    let animationFrameId = null;
    let hasSignificantAudio = false; // Tracking ob signifikantes Audio erkannt wurde
    let audioLevelSamples = []; // Speichert Audio-Level für Durchschnitts-Berechnung

    let isAudioEnabled = sessionStorage.getItem('mw_ai_audio_enabled') === 'true';
    let chatStarted = false; // Neue Variable um zu tracken, ob Chat gestartet hat
    let isWaitingForResponse = false;
    let sessionId = null; // Session-ID für Logging
    let sessionSecurityToken = null; // Security Token für API-Calls
    let promptId = (window.mwRealtimeAiConfig && mwRealtimeAiConfig.running_id) || '';

    // ===== Prompt-Router (Route-to-Slave) =====
    const routerConfig = (window.mwRealtimeAiConfig && mwRealtimeAiConfig.router) || {};
    const ROUTER_ENABLED = !!(routerConfig.enabled && Array.isArray(routerConfig.slots) && routerConfig.slots.length > 0);
    let currentSlotSlug = ROUTER_ENABLED ? (routerConfig.initial_slot || routerConfig.slots[0]?.slug || '') : '';
    let lastUserTextForRouter = '';
    let lastAssistantTextForRouter = '';
    let routerCallInFlight = false;
    let routerDone = false;

    // Tool-Specs kommen aus dem Backend (run.php → OpenAi::get_all_tool_specs()).
    // Single source of truth in PHP, hier nur konsumieren.
    const REALTIME_TOOL_SPECS = (window.mwRealtimeAiConfig && mwRealtimeAiConfig.tool_specs) || {};

    const findSlotBySlug = (slug) => {
        if (!ROUTER_ENABLED || !slug) return null;
        return routerConfig.slots.find(s => s.slug === slug) || null;
    };

    const buildToolsForSlot = (slot) => {
        if (!slot || !slot.tools) return [];
        const out = [];
        Object.keys(slot.tools).forEach(k => {
            if (slot.tools[k] && REALTIME_TOOL_SPECS[k]) {
                out.push(REALTIME_TOOL_SPECS[k]);
            }
        });
        return out;
    };

    const composeInstructionsForSlot = (slot) => {
        const base = (routerConfig.base_instructions || '').trim();
        const slotText = (slot?.instructions || '').trim();
        const heading = 'Aktuelle Phase: ' + (slot?.label || slot?.slug || '');
        const parts = [];
        if (base) parts.push(base);
        parts.push('---\n\n' + heading + (slotText ? '\n' + slotText : ''));
        return parts.join('\n\n');
    };

    const applySlotViaSessionUpdate = (slot, dc) => {
        if (!slot || !dc || dc.readyState !== 'open') return;
        try {
            dc.send(JSON.stringify({
                type: 'session.update',
                session: {
                    type: 'realtime',
                    instructions: composeInstructionsForSlot(slot),
                    tools: buildToolsForSlot(slot)
                }
            }));
            currentSlotSlug = slot.slug;
            console.log('[Realtime][Router] Slot aktiv:', slot.slug);
        } catch (err) {
            console.error('[Realtime][Router] session.update fehlgeschlagen:', err);
        }
    };

    const callRouterEndpoint = async () => {
        if (!ROUTER_ENABLED || routerDone || routerCallInFlight) return null;

        routerCallInFlight = true;
        try {
            const historyTail = loadChatHistory().slice(-10);
            const payload = {
                running_id: promptId,
                session_id: sessionId,
                security_token: sessionSecurityToken,
                current_slot: currentSlotSlug,
                last_user_text: lastUserTextForRouter,
                last_assistant_text: lastAssistantTextForRouter,
                history: historyTail
            };

            const res = await fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/router_dispatch', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce },
                body: JSON.stringify(payload)
            });
            return await res.json().catch(() => null);
        } catch (err) {
            console.warn('[Realtime][Router] Aufruf fehlgeschlagen:', err);
            return null;
        } finally {
            routerCallInFlight = false;
        }
    };

    const handleRouterAfterAssistantResponse = async (dcInstance) => {
        if (!ROUTER_ENABLED || routerDone) return;
        const result = await callRouterEndpoint();
        if (!result) return;

        if (result.done) {
            routerDone = true;
            console.log('[Realtime][Router] Flow abgeschlossen.');
            return;
        }
        if (result.stay) {
            return;
        }
        const nextSlug = result.next_slot || '';
        if (!nextSlug || nextSlug === currentSlotSlug) {
            return;
        }
        const nextSlot = findSlotBySlug(nextSlug);
        if (!nextSlot) {
            console.warn('[Realtime][Router] Unbekannter Slot:', nextSlug);
            return;
        }
        applySlotViaSessionUpdate(nextSlot, dcInstance);
    };
    let micPermissionGranted = false; // Tracking ob Mikrofon-Berechtigung bereits erteilt wurde
    let isAiSpeaking = false; // Tracking ob KI gerade spricht
    const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (remoteAudioEl) {
        remoteAudioEl.muted = !isAudioEnabled;
    }

    sessionStorage.setItem('ai_init_placeholder', user_input_field.getAttribute('placeholder'));
    const disable_text_and_display_placeholder = function (field) {
        field.disabled = true;
        field.placeholder = 'Bitte warten...';
    }

    const reset_text_and_show_old_placeholder = function (field) {
        field.disabled = false;
        field.placeholder = sessionStorage.getItem('ai_init_placeholder');
    }

    const hide_intro_fields = function(chatStarted = false) {
        if ( ! chatStarted ) {
            const introWrapper = document.querySelector('.mw-ai-realtime-intro-wrapper');
            const innerWrapper = document.querySelector('.mw-ai-realtime-inner-wrapper');
            if (introWrapper) {
                introWrapper.style.display = 'none';
            }
            if (faqExamples) {
                faqExamples.style.display = 'none';
            }
            if (innerWrapper) {
                innerWrapper.style.gridTemplateRows = 'auto 1fr auto';
            }
        }
    }

    // Nachricht zum Chat-Fenster hinzufügen
    const addMessageToChat = (text, role = 'user', options = {}) => {
        if (!chatWindow || !text) return;

        const {linkHref, linkLabel, persist = true} = options;

        // Beim ersten Chat-Eintrag: Intro und FAQ ausblenden
        hide_intro_fields( chatStarted );
        chatStarted = true;

        const msgDiv = document.createElement('div');
        msgDiv.className = `mw-msg mw-msg--${role}`;

        const bubble = document.createElement('div');
        bubble.className = 'mw-msg__bubble';
        const finalLinkHref = linkHref;
        const finalLinkLabel = linkLabel || finalLinkHref;

        if (finalLinkHref) {
            if (text) {
                bubble.appendChild(document.createTextNode(text + ' '));
            }
            const linkEl = document.createElement('a');
            linkEl.href = finalLinkHref;
            linkEl.target = '_blank';
            linkEl.rel = 'noopener noreferrer';
            linkEl.textContent = finalLinkLabel;
            bubble.appendChild(linkEl);
        } else {
            bubble.textContent = text;
        }

        msgDiv.appendChild(bubble);
        chatWindow.appendChild(msgDiv);

        if (persist) {
            persistHistoryMessage(role, text, finalLinkHref || '', finalLinkLabel || '');
        }

        // Automatisch zum letzten Element scrollen
        setTimeout(() => {
            chatWindow.scrollTop = chatWindow.scrollHeight;
        }, 0);
    };

    const chatForm = document.querySelector('.mw-ai-realtime-input-area');
    let dcRef = null;
    let currentAssistantMessage = '';
    let assistantStreamBubble = null; // Bubble, die während des Streams live aktualisiert wird
    let userStreamBubble = null; // Bubble, die die laufende Spracherkennung zeigt
    let hasReplayedHistoryForSession = false;

    // Gespeicherten Verlauf ins UI laden (ohne erneut zu speichern)
    const initialHistory = loadChatHistory();
    if (isHistoryEnabled && initialHistory.length > 0) {
        hide_intro_fields();
        chatStarted = true;
        initialHistory.forEach(msg => {
            addMessageToChat(msg.text, msg.role || 'user', {
                persist: false,
                linkHref: msg.linkHref || '',
                linkLabel: msg.linkLabel || ''
            });
        });
    }


    const sendUserMessage = async (text, showInChat = true) => {
        if (!text) return;
        placeholderRotator.stop();

        lastUserTextForRouter = text;

        // Beim Senden immer sicherstellen, dass das Mikrofon wieder eingeblendet ist.
        document.querySelectorAll( '.mw-ai-realtime-mute' ).forEach( el => el.style.display = 'flex' );

        if (showInChat) {
            addMessageToChat(text, 'user');
        }
        showLoadingIndicator();

        if (!dcRef || dcRef.readyState !== 'open') {
            console.warn('[Realtime] DataChannel nicht offen, kann nicht senden');
            hideLoadingIndicator();
            return;
        }

        try {
            // 1. User-Message in den OpenAI-Buffer schreiben (noch keine Antwort triggern)
            dcRef.send(JSON.stringify({
                type: 'conversation.item.create', item: {
                    type: 'message', role: 'user', content: [{type: 'input_text', text}]
                }
            }));

            // 2. Router fragen — VOR der Antwort, damit der richtige Slot/Tools aktiv sind
            if (ROUTER_ENABLED && !routerDone) {
                const result = await callRouterEndpoint();
                if (result) {
                    if (result.done) {
                        routerDone = true;
                        console.log('[Realtime][Router] Flow abgeschlossen.');
                    } else if (result.next_slot && result.next_slot !== currentSlotSlug) {
                        const nextSlot = findSlotBySlug(result.next_slot);
                        if (nextSlot) {
                            applySlotViaSessionUpdate(nextSlot, dcRef);
                        } else {
                            console.warn('[Realtime][Router] Unbekannter Slot:', result.next_slot);
                        }
                    }
                }
            }

            // 3. Antwort triggern — mit jetzt korrektem Slot + Tools
            dcRef.send(JSON.stringify({
                type: 'response.create',
                response: {
                    output_modalities: [isAudioEnabled ? 'audio' : 'text']
                }
            }));
        } catch (e) {
            console.warn('[Realtime] Fehler beim Senden via DataChannel:', e);
            hideLoadingIndicator();
        }
    };

    // Funktionen für Loading-Indicator
    const showLoadingIndicator = ( in_function_context = false ) => {
        const loadingEl = document.querySelector('.mw-ai-loading-indicator');
        if (loadingEl) {
            loadingEl.style.display = 'block';
            isWaitingForResponse = true;
            chatWindow.scrollTop = chatWindow.scrollHeight;
        }
    };

    const hideLoadingIndicator = () => {
        const loadingEl = document.querySelector('.mw-ai-loading-indicator');
        if (loadingEl) {
            loadingEl.style.display = 'none';
            isWaitingForResponse = false;
        }
    };


    // ===== Form Submit Handler (Text-Eingabe) =====
    if (chatForm) {
        chatForm.addEventListener('submit', function (e) {
            e.preventDefault();
            console.log('[Realtime] Form submit triggered. isRecording:', isRecording);

            // Falls grade noch der Record Button aktiv ist: Recording stoppen, Flag setzen
            // und auf Transkription warten. Das Absenden erfolgt im isUserTranscriptDone-Handler.
            if (isRecording) {
                pendingSubmitAfterTranscription = true;
                recordBtn.forEach((btn) => {
                    btn.click();
                });
                return;
            }

            const text = (user_input_field.value || '').trim();
            if (!text) return;
            user_input_field.value = '';
            sendUserMessage(text);
        });
    }

    // ===== Enter-Taste in Textarea =====
    user_input_field.addEventListener('keydown', function (e) {
        // Enter ohne Shift = senden, Enter + Shift = Zeilenumbruch
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            const text = (this.value || '').trim();
            if (!text) return;
            this.value = '';
            sendUserMessage(text);
        }
    });

    let recordBtn_tmp = document.querySelectorAll('.mw-ai-realtime-mute');
    user_input_field.addEventListener('input', function (e) {
        // Mikrofon verstecken, wenn getippt wird.
        if ( this.value !== '' && this.value !== ' ' ) {
            recordBtn_tmp.forEach((btn) => {
                btn.style.display = 'none';
            } )
        } else {
            recordBtn_tmp.forEach((btn) => {
                btn.style.display = 'flex';
            } )
        }
    });

    // Auto-open bei URL-Parameter mw_reopen_ai=true
    const searchParams = new URLSearchParams(window.location.search);
    const shouldAutoOpen = (searchParams.get('mw_reopen_ai') === 'true');

    if (shouldAutoOpen && dialog) {
        if ('1' !== sessionStorage.getItem('mw_ai_consent')) {
            disclaimer_dialog.showModal();
        }

        if ('1' === sessionStorage.getItem('mw_ai_consent')) {
            if (!isSessionActive) {
                start_gpt_connect();
                isSessionActive = true;
            }

            // Prüfen ob mobiles Gerät
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

            if (isMobile) {
                // Minimiert starten
                minimize_window_btn.click();
            } else {
                // Normal öffnen
                open_ai_dialog(dialog);
            }
        } else {
            open_ai_dialog(dialog);
        }
    }

    // Audio-Visualisierung starten - vertikale Balken in Grautönen
    const startAudioVisualization = () => {
        if (!micStreamRef || !audioContext || !analyserNode) return;

        const canvas = document.querySelector('.mw-audio-visualizer');
        if (!canvas) return;

        const canvasContext = canvas.getContext('2d');
        analyserNode.fftSize = 128; // Kleinere FFT für weniger Balken
        analyserNode.smoothingTimeConstant = 0.85; // Hohe Glättung
        const bufferLength = analyserNode.frequencyBinCount;
        const dataArray = new Uint8Array(bufferLength);

        let previousAmplitudes = new Array(bufferLength).fill(0);

        const draw = () => {
            if (!isRecording) return;

            animationFrameId = requestAnimationFrame(draw);
            analyserNode.getByteFrequencyData(dataArray); // Frequenz-Daten für Balken

            // Audio-Level berechnen für Erkennung
            const average = dataArray.reduce((a, b) => a + b, 0) / dataArray.length;
            const max = Math.max(...dataArray);
            audioLevelSamples.push({ average, max, timestamp: Date.now() });

            // Nur letzte 60 Samples behalten (ca. 1 Sekunde bei 60fps)
            if (audioLevelSamples.length > 60) {
                audioLevelSamples.shift();
            }

            // Signifikantes Audio erkennen - höhere Schwellenwerte gegen Rauschen
            // Mindestens 30% der Samples müssen über dem Schwellenwert liegen
            if (average > 40 || max > 80) {
                hasSignificantAudio = true;
            }

            // Canvas komplett leeren
            canvasContext.clearRect(0, 0, canvas.width, canvas.height);

            const barWidth = (canvas.width / bufferLength) * 2.5;
            const barSpacing = 2;
            let x = 0;

            for (let i = 0; i < bufferLength; i++) {
                // Glättung durch Interpolation
                const targetHeight = dataArray[i];
                const smoothedHeight = previousAmplitudes[i] + (targetHeight - previousAmplitudes[i]) * 0.25;
                previousAmplitudes[i] = smoothedHeight;

                // Höhe des Balkens berechnen (von unten nach oben)
                const barHeight = (smoothedHeight / 255) * canvas.height * 0.8; // Maximal 80% der Canvas-Höhe

                // Grauton basierend auf Intensität
                const intensity = Math.floor((smoothedHeight / 255) * 100);
                const grayValue = 100 + intensity; // Zwischen rgb(100,100,100) und rgb(200,200,200)
                canvasContext.fillStyle = `rgba(${grayValue}, ${grayValue}, ${grayValue}, 0.7)`;

                // Balken von unten nach oben zeichnen
                canvasContext.fillRect(
                    x,
                    canvas.height - barHeight,
                    barWidth - barSpacing,
                    barHeight
                );

                x += barWidth;
            }
        };

        draw();
    };

    // Audio-Visualisierung stoppen
    const stopAudioVisualization = () => {
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = null;
        }
    };

    // ===== Verbindung starten =====
    async function start_gpt_connect() {
        disable_text_and_display_placeholder(user_input_field);

        if ( ! document.querySelector( '.logged-in' ) ) {
            await refreshNonce();
        }

        if (chatWindow) {
            chatWindow.scrollTop = chatWindow.scrollHeight;
        }

        // Session starten
        await startSession();

        try {
            const pc = new RTCPeerConnection();
            pcRef = pc;

            pc.ontrack = (event) => {
                const [remoteStream] = event.streams;
                if (remoteStream) {
                    remoteAudioEl.srcObject = remoteStream;
                    // iOS benötigt explizites play() nach User-Interaktion
                    if (isIOS) {
                        remoteAudioEl.play().catch(err => {
                            console.warn('[Realtime] Audio-Wiedergabe auf iOS blockiert:', err);
                        });
                    }
                }
            };

            pc.oniceconnectionstatechange = () => {

            };

            // DataChannel erstellen
            const dc = pc.createDataChannel('oai-events');
            dcRef = dc;

            currentAssistantMessage = '';
            assistantStreamBubble = null;
            hasReplayedHistoryForSession = false;

            const buildContextMessage = (ctx) => {
                const title = (ctx && ctx.title) ? String(ctx.title) : document.title;
                const url = (ctx && ctx.url) ? String(ctx.url) : window.location.href;

                const excerpt = (ctx && ctx.excerpt) ? String(ctx.excerpt) : '';
                const content = (ctx && ctx.content) ? String(ctx.content) : '';

                // Kurz & klar: so versteht das Modell, was es damit soll.
                // (Bewusst als "user"-Message, aber ohne response.create => kein Auto-Reply)
                return [
                    'Kontext zur aktuell geöffneten Seite (nur zur Orientierung, nicht als Nutzerfrage):',
                    `Titel: ${title}`,
                    `URL: ${url}`,
                    ctx && ctx.post_id ? `Post-ID: ${ctx.post_id}` : '',
                    excerpt ? `Kurzbeschreibung: ${excerpt}` : '',
                    content ? `Inhalt (Auszug):\n${content}` : '',
                    '',
                    'Wenn der Nutzer Fragen stellt, beziehe dich auf diesen Seitenkontext.'
                ].filter(Boolean).join('\n');
            };

            const fetchPageContext = async () => {
                const res = await fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/page_context', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': mwRealtimeAiConfig.nonce
                    },
                    body: JSON.stringify({
                        url: window.location.href,
                        session_id: sessionId,
                        running_id: mwRealtimeAiConfig.running_id,
                        post_id: mwRealtimeAiConfig.post_id,
                        security_token: sessionSecurityToken
                    })
                });
                const json = await res.json().catch(() => null);
                return json || null;
            };

            const maybeInjectPageContext = async () => {
                let should_get_context = false;
                if ( true === shouldAutoOpen || true === mwRealtimeAiConfig.always_load_post_data ) {
                    should_get_context = true;
                }
                if ( should_get_context ) {
                    try {
                        const ctx = await fetchPageContext();
                        const msg = buildContextMessage(ctx);

                        if (dcRef && dcRef.readyState === 'open' && msg) {
                            dcRef.send(JSON.stringify({
                                type: 'conversation.item.create',
                                item: {
                                    type: 'message',
                                    role: 'user',
                                    content: [{ type: 'input_text', text: msg }]
                                }
                            }));
                        }
                    } catch (e) {
                        console.warn('[Realtime] Konnte Page-Context nicht injizieren:', e);
                    }
                }
            };

            dc.onopen = async () => {
                isConnectionReady = true;
                sessionStorage.setItem('mw_realtime_session_ready', '1');
                window.dispatchEvent(new CustomEvent("mw_realtime_session_ready", {
                    detail: {ready: true}, bubbles: true
                }));

                // Session initial konfigurieren: VAD deaktivieren, damit nur manuelles Recording funktioniert
                // GA-Schema: audio.input.turn_detection / audio.input.transcription, session.type = 'realtime'
                try {
                    const initSession = {
                        type: 'realtime',
                        audio: {
                            input: {
                                turn_detection: null, // VAD deaktivieren - verhindert automatische Responses
                                transcription: {
                                    model: 'whisper-1',
                                    language: 'de' // Sprache auf Deutsch setzen
                                }
                            }
                        }
                    };

                    // Router-Mode: Initial-Slot Instructions + Tools setzen
                    if (ROUTER_ENABLED) {
                        const initialSlot = findSlotBySlug(currentSlotSlug) || routerConfig.slots[0];
                        if (initialSlot) {
                            initSession.instructions = composeInstructionsForSlot(initialSlot);
                            initSession.tools = buildToolsForSlot(initialSlot);
                            currentSlotSlug = initialSlot.slug;
                            console.log('[Realtime][Router] Initial-Slot:', initialSlot.slug);
                        }
                    }

                    dc.send(JSON.stringify({
                        type: 'session.update',
                        session: initSession
                    }));
                    console.log('[Realtime] Session initialized with VAD disabled and German language');
                } catch (err) {
                    console.error('[Realtime] Error initializing session:', err);
                }

                // Vergangene Nachrichten in die neue Session einspeisen, damit das Modell Kontext hat
                if (isHistoryEnabled && !hasReplayedHistoryForSession) {
                    const history = loadChatHistory();
                    if (Array.isArray(history) && history.length) {
                        history.forEach(msg => {
                            if (!msg?.text) return;
                            const role = msg.role === 'assistant' ? 'assistant' : 'user';
                            try {
                                dc.send(JSON.stringify({
                                    type: 'conversation.item.create',
                                    item: {
                                        type: 'message',
                                        role,
                                        content: [{type: 'input_text', text: msg.text}]
                                    }
                                }));
                            } catch (err) {
                                console.warn('[Realtime] Kontext konnte nicht gesendet werden:', err);
                            }
                        });

                        dc.send(JSON.stringify({
                            type: 'conversation.item.create',
                            item: {
                                type: 'message',
                                role: 'user',
                                content: [{ type: 'input_text', text: "Der Chat wurde mit einer Chathistorie initialisiert. (nur zur Orientierung, nicht als Nutzerfrage) Bitte führe keine Aktion oder Funktion aus, bis der Benutzer dich explizit erneut dazu auffordert." }]
                            }
                        }));

                        hasReplayedHistoryForSession = true;

                        // Nach unten scrollen wenn Historie geladen wurde
                        setTimeout(() => {
                            if (chatWindow) {
                                chatWindow.scrollTop = chatWindow.scrollHeight;
                            }
                        }, 100);
                    }
                }

                // Gespeicherte Nachrichten aus Queue abarbeiten
                if (messageQueue.length > 0) {
                    messageQueue.forEach(queueItem => {
                        sendUserMessage(queueItem.text, queueItem.showInChat);
                    });
                    messageQueue = [];
                }

                await maybeInjectPageContext();

            };

            dc.onclose = () => {
                isConnectionReady = false;
            };

            dc.onerror = (error) => {

            };

            // Funktion zum nachträglichen Hinzufügen des Mikrofon-Streams
            const addMicrophoneStream = async () => {
                if (micStreamRef || micPermissionGranted) return; // Bereits vorhanden

                try {
                    const micStream = await navigator.mediaDevices.getUserMedia({
                        audio: {
                            echoCancellation: true, noiseSuppression: true, autoGainControl: true
                        }, video: false
                    });
                    micStreamRef = micStream;
                    micPermissionGranted = true;

                    // Initial alle Tracks deaktivieren (nur bei Bedarf aktivieren)
                    micStreamRef.getAudioTracks().forEach(track => {
                        track.enabled = false;
                    });

                    // AudioContext für Visualisierung erstellen
                    if (!audioContext) {
                        audioContext = new (window.AudioContext || window.webkitAudioContext)();
                        const source = audioContext.createMediaStreamSource(micStream);
                        analyserNode = audioContext.createAnalyser();
                        analyserNode.fftSize = 2048;
                        source.connect(analyserNode);
                    }

                    // Track zur bestehenden PeerConnection hinzufügen
                    if (pcRef) {
                        for (const track of micStream.getAudioTracks()) {
                            pcRef.addTrack(track, micStream);
                        }
                    }
                } catch (err) {
                    console.error('[Realtime] Fehler beim Zugriff auf Mikrofon:', err);
                }
            };

            dc.onmessage = async (e) => {
                try {
                    const evt = JSON.parse(e.data);

                    // Debug: Alle Events loggen während Recording
                    if (isRecording) {
                        console.log('[Realtime] Event during recording:', evt.type, evt);
                    }

                    // Events blockieren die während Manual Recording KEINE Response triggern sollen
                    if (isRecording && (
                        evt?.type === 'conversation.item.created' ||
                        evt?.type === 'input_audio_buffer.committed' ||
                        evt?.type === 'input_audio_buffer.speech_stopped'
                    )) {
                        console.log('[Realtime] Blocking event during recording:', evt.type);
                        return; // Event ignorieren
                    }

                    // ===== Audio-Ausgabe startet (KI beginnt zu sprechen) =====
                    if (
                        evt?.type === 'response.audio_transcript.delta' ||
                        evt?.type === 'response.audio.delta' ||
                        evt?.type === 'response.output_audio_transcript.delta' ||
                        evt?.type === 'response.output_audio.delta'
                    ) {
                        if (!isAiSpeaking) {
                            isAiSpeaking = true;
                        }
                    }

                    // ===== Audio-Ausgabe beendet (KI hat fertig gesprochen) =====
                    if (evt?.type === 'output_audio_buffer.stopped') {
                        if (isAiSpeaking) {
                            isAiSpeaking = false;
                        }
                    }

                    // ===== KI-Antwort erfassen =====
                    if (isAssistantTextDelta(evt?.type)) {
                        if (typeof evt.delta === 'string' && evt.delta.length) {
                            currentAssistantMessage += evt.delta;
                            // Bubble bei der ersten Delta-Antwort erzeugen
                            if (!assistantStreamBubble) {
                                const msgDiv = document.createElement('div');
                                msgDiv.className = 'mw-msg mw-msg--assistant is-streaming';
                                assistantStreamBubble = document.createElement('div');
                                assistantStreamBubble.className = 'mw-msg__bubble';
                                msgDiv.appendChild(assistantStreamBubble);
                                chatWindow.appendChild(msgDiv);
                            }
                            assistantStreamBubble.textContent = currentAssistantMessage;
                            if (isWaitingForResponse) {
                                hideLoadingIndicator();
                            }
                            chatWindow.scrollTop = chatWindow.scrollHeight;
                            hide_intro_fields( chatStarted );
                            chatStarted = true;
                        }
                    } else if (isAssistantTextDone(evt?.type)) {
                        if (currentAssistantMessage.trim()) {
                            if (assistantStreamBubble) {
                                assistantStreamBubble.textContent = currentAssistantMessage;
                                assistantStreamBubble.parentElement?.classList.remove('is-streaming');
                                persistHistoryMessage('assistant', currentAssistantMessage);
                            } else {
                                addMessageToChat(currentAssistantMessage, 'assistant');
                            }
                            if (isWaitingForResponse) {
                                hideLoadingIndicator();
                            }
                            lastAssistantTextForRouter = currentAssistantMessage;
                            currentAssistantMessage = '';
                            assistantStreamBubble = null;
                        }
                    }

                    // ===== Audio-Ausgabe kontrollieren (Modalities anpassen) =====
                    if (evt?.type === 'response.done') {
                        // Router läuft jetzt VOR der Antwort (siehe sendUserMessage).
                        // Hier nichts mehr zu tun — lastAssistantTextForRouter wurde bereits
                        // im isAssistantTextDone-Pfad gesetzt und steht für den nächsten Turn bereit.
                    }

                    // ===== Spracheingabe des Nutzers =====
                    if (isUserTranscriptDelta(evt?.type)) {
                        const deltaText = extractTranscriptText(evt);
                        console.log('[Realtime] Transcript delta:', deltaText, 'isRecording:', isRecording, 'wasRecording:', wasRecording);
                        if (deltaText && typeof deltaText === 'string' && deltaText.length > 0) {
                            if (isRecording || wasRecording) {
                                // Nur ins Eingabefeld schreiben, nicht senden
                                const currentValue = user_input_field.value || '';
                                user_input_field.value = currentValue + deltaText;
                            } else {
                                // Alte Logik für automatische Transkription (falls nicht im Recording-Modus)
                                const currentValue = user_input_field.value || '';
                                user_input_field.value = currentValue + deltaText;
                            }
                        }
                    } else if (isUserTranscriptDone(evt?.type)) {
                        const extracted = extractTranscriptText(evt);
                        const trimmedExtracted = (typeof extracted === 'string' && extracted) ? extracted.trim() : '';
                        console.log('[Realtime] Transcript done:', trimmedExtracted, 'isRecording:', isRecording, 'wasRecording:', wasRecording);
                        if (trimmedExtracted && trimmedExtracted.length > 0) {
                            if (isRecording || wasRecording) {
                                // Nur ins Eingabefeld schreiben, NICHT automatisch senden
                                user_input_field.value = trimmedExtracted;
                                console.log('[Realtime] Text written to input field, waiting for user to send');
                                // Loading State verstecken
                                setTranscriptionLoading(false);
                                // wasRecording Flag zurücksetzen nach erfolgreicher Transkription
                                wasRecording = false;

                                // Falls User während Recording auf "Senden" gedrückt hat:
                                // jetzt automatisch den transkribierten Text absenden.
                                if (pendingSubmitAfterTranscription) {
                                    pendingSubmitAfterTranscription = false;
                                    user_input_field.value = '';
                                    sendUserMessage(trimmedExtracted);
                                }
                            } else {
                                // Alte Logik: automatisch senden wenn nicht im Recording-Modus
                                if (userStreamBubble) {
                                    userStreamBubble.textContent = trimmedExtracted;
                                    userStreamBubble.parentElement?.classList.remove('is-streaming');
                                    persistHistoryMessage('user', trimmedExtracted);
                                } else {
                                    addMessageToChat(trimmedExtracted, 'user');
                                }

                                if (dcRef && dcRef.readyState === 'open') {
                                    try {
                                        dcRef.send(JSON.stringify({
                                            type: 'conversation.item.create', item: {
                                                type: 'message',
                                                role: 'user',
                                                content: [{type: 'input_text', text: trimmedExtracted}]
                                            }
                                        }));
                                        dcRef.send(JSON.stringify({
                                            type: 'response.create', response: {
                                                output_modalities: [isAudioEnabled ? 'audio' : 'text']
                                            }
                                        }));
                                    } catch (err) {
                                        console.error('[Realtime] Error sending message:', err);
                                    }
                                }
                                user_input_field.value = '';
                                userStreamBubble = null;
                            }
                        }
                    } else if (evt?.type && USER_TRANSCRIPT_REGEX.test(evt.type)) {
                        // Fallback für neue Varianten von Transcript-Events
                        const fallbackText = extractTranscriptText(evt);
                        const trimmedFallback = (typeof fallbackText === 'string' && fallbackText) ? fallbackText.trim() : '';
                        if (trimmedFallback && trimmedFallback.length > 0) {
                            console.log('[Realtime] Transcript fallback:', trimmedFallback, 'isRecording:', isRecording);
                            if (isRecording) {
                                user_input_field.value = trimmedFallback;
                            } else {
                                addMessageToChat(trimmedFallback, 'user');
                                user_input_field.value = '';
                                userStreamBubble = null;
                            }
                        }
                    }

                    // ===== Audio-Ausgabe beendet - Weiterleitung durchführen =====
                    // Wenn Speaker aktiv: warte auf output_audio_buffer.stopped
                    // Wenn Speaker inaktiv: warte auf response.done
                    const shouldRedirect = (isAudioEnabled && evt?.type === 'output_audio_buffer.stopped') ||
                                          (!isAudioEnabled && evt?.type === 'response.done');

                    if (shouldRedirect && window.mwWaitingForAudioRedirect) {
                        const redirectUrl = window.mwWaitingForAudioRedirect;
                        window.mwWaitingForAudioRedirect = null;
                        if ( ! isAudioEnabled ) {
                            setTimeout( function() {
                                window.open(redirectUrl, '_self');
                            }, 500 )
                        } else {
                            window.open(redirectUrl, '_self');
                        }
                    }



                    if ( evt?.type === 'response.function_call_arguments.done' ) {
                        const { name: fnName, arguments: fnArgs, call_id: callId } = evt || {};
                        const safeCallId = callId || evt?.callId || '';

                        const sendFunctionOutput = (outputPayload) => {
                            try {
                                dc.send(JSON.stringify({
                                    type: 'conversation.item.create',
                                    item: {
                                        type: 'function_call_output',
                                        call_id: safeCallId,
                                        output: typeof outputPayload === 'string' ? outputPayload : JSON.stringify(outputPayload || {})
                                    }
                                }));
                            } catch (err) {
                                console.error('[Realtime] Fehler beim Senden von function_call_output:', err);
                            }
                        };

                        const requestNewResponse = (responseOverrides = {}) => {
                            try {
                                dc.send(JSON.stringify({
                                    type: 'response.create',
                                    response: responseOverrides
                                }));
                            } catch (_) {
                            }
                        };

                        if ( fnName === 'write_mail' ) {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/write_mail', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                },
                                body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || { results: [] });
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                hideLoadingIndicator();
                                sendFunctionOutput({ ok: false, error: String(err), results: [] });
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich, dass leider die E-Mail nicht versendet werden konnte.'
                                });
                            });
                        }

                        if ( fnName === 'search_knowledge' ) {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/search_knowledge', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                },
                                body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || { results: [] });
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                console.error('[Realtime] Fehler bei Knowledge-Suche:', err);
                                hideLoadingIndicator();
                                sendFunctionOutput({ ok: false, error: String(err), results: [] });
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich, dass keine Informationen gefunden wurden.'
                                });
                            });
                        }

                        if ( fnName === 'click_class_by_query' ) {
                            let current_selector = JSON.parse(fnArgs).selector
                            console.log('click_class_by_query', current_selector )
                            if ( current_selector && document.querySelector(current_selector) ) {
                                document.querySelector(current_selector).click();
                            }
                            sendFunctionOutput(data || { results: [] });
                            requestNewResponse({
                                output_modalities: ['audio']
                            });
                        }

                        if ( fnName === 'fill_value_by_query' ) {
                            let current_selector = JSON.parse(fnArgs).selector
                            let value2write = JSON.parse(fnArgs).value
                            console.log('fill_value_by_query', current_selector, value2write)
                            if ( current_selector && document.querySelector(current_selector) ) {
                                document.querySelector(current_selector).value = value2write;
                            }
                            sendFunctionOutput(data || { results: [] });
                            requestNewResponse({
                                output_modalities: ['audio']
                            });
                        }

                        if ( fnName === 'get_vectore_store' ) {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/get_vectore_store', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                },
                                body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || { results: [] });
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                console.error('[Realtime] Fehler bei Vector-Suche:', err);
                                hideLoadingIndicator();
                                sendFunctionOutput({ ok: false, error: String(err), results: [] });
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich, dass keine Informationen gefunden wurden.'
                                });
                            });
                        }

                        if ( fnName === 'get_post_by_category' ) {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/get_post_by_category', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                },
                                body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || { results: [] });
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                hideLoadingIndicator();
                                sendFunctionOutput({ ok: false, error: String(err), results: [] });
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich, dass keine Informationen gefunden wurden.'
                                });
                            });
                        }

                        if (fnName === 'get_module_list') {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/get_module_list', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                },
                                body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || {results: []});
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                hideLoadingIndicator();
                                sendFunctionOutput({ok: false, error: String(err), results: []});
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich, dass keine Informationen gefunden wurden.'
                                });
                            });
                        }

                        if (fnName === 'search_prop') {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/search_prop', {
                                method: 'POST', headers: {
                                    'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                }, body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || {results: []});
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                hideLoadingIndicator();
                                sendFunctionOutput({ok: false, error: String(err), results: []});
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich, dass keine Informationen gefunden wurden.'
                                });
                            });
                        }

                        if (fnName === 'search_modules') {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/search_modules', {
                                method: 'POST', headers: {
                                    'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                }, body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || {results: []});
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                hideLoadingIndicator();
                                sendFunctionOutput({ok: false, error: String(err), results: []});
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich, dass keine Informationen gefunden wurden.'
                                });
                            });
                        }

                        if (fnName === 'get_module_details') {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/get_module_by_id', {
                                method: 'POST', headers: {
                                    'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                }, body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || {results: []});
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                hideLoadingIndicator();
                                sendFunctionOutput({ok: false, error: String(err), results: []});
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich, dass keine Informationen gefunden wurden.'
                                });
                            });
                        }

                        if (fnName === 'send_data_to_webhook') {

                            showLoadingIndicator(true);

                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/function', {
                                method: 'POST', headers: {
                                    'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                }, body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || { ok: true });
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                console.error('[Realtime] Fehler bei Webhook anfrage:', err);
                                sendFunctionOutput({ ok: false, error: String(err) });
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich und bitte den Benutzer, es erneut zu versuchen.'
                                });
                            });
                        }

                        if (fnName === 'read_sitemap_by_name') {

                            showLoadingIndicator(true);

                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/read_sitemap_by_name', {
                                method: 'POST', headers: {
                                    'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                }, body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || { ok: true });
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                sendFunctionOutput({ ok: false, error: String(err) });
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich und bitte den Benutzer, es erneut zu versuchen.'
                                });
                            });
                        }

                        if ( fnName === 'single_whitelist_meta_prompt' ) {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/single_whitelist_meta_prompt', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                },
                                body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken,
                                    post_id: mwRealtimeAiConfig.post_id || 0
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                sendFunctionOutput(data || { ok: true });
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                            }).catch(err => {
                                hideLoadingIndicator();
                                sendFunctionOutput({ ok: false, error: String(err) });
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich und sage, dass der angefragte Immobilientext gerade nicht erstellt werden konnte.'
                                });
                            });
                        }

                        if ( fnName === 'request_open_link' ) {
                            showLoadingIndicator(true);
                            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/request_open_link', {
                                method: 'POST', headers: {
                                    'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce
                                }, body: JSON.stringify({
                                    ...(typeof fnArgs === 'string' ? JSON.parse(fnArgs) : fnArgs),
                                    running_id: mwRealtimeAiConfig.running_id,
                                    session_id: sessionId,
                                    security_token: sessionSecurityToken
                                })
                            }).then(response => response.json()).then(data => {
                                hideLoadingIndicator();
                                const linkToOpen = data?.message?.link_to_open || '';
                                requestNewResponse({
                                    output_modalities: ['audio']
                                });
                                const appendQueryParam = (url, key, value) => {
                                    if (!url) return url;

                                    const sep = url.includes('?') ? '&' : '?';
                                    return url + sep + encodeURIComponent(key) + '=' + encodeURIComponent(value);
                                };
                                const finalUrl = appendQueryParam(linkToOpen, 'mw_reopen_ai', 'true');

                                // Flag setzen, dass wir auf Audio-Ende warten
                                window.mwWaitingForAudioRedirect = finalUrl;
                            }).catch(err => {
                                console.error('[Realtime] Fehler bei Webhook anfrage:', err);
                                sendFunctionOutput({ ok: false, error: String(err) });
                                requestNewResponse({
                                    output_modalities: ['audio'],
                                    instructions: 'Entschuldige dich und bitte den Benutzer, es erneut zu versuchen.'
                                });
                            });
                        }

                    }

                } catch (err) {

                }
            };

            // Transceiver hinzufügen um Audio-Slot im SDP zu reservieren
            // Mikrofon wird erst bei Bedarf (Button-Klick) aktiviert
            pc.addTransceiver('audio', { direction: 'sendrecv' });

            // Offer erstellen
            const offer = await pc.createOffer({offerToReceiveAudio: true});
            await pc.setLocalDescription(offer);

            // Anfrage an Backend
            let data = await mw_open_ai_realtime_call_init({
                sdp: offer.sdp,
                type: offer.type,
                running_id: (window.mwRealtimeAiConfig && mwRealtimeAiConfig.running_id) || '',
                session: (window.mwRealtimeAiConfig && mwRealtimeAiConfig.session) || undefined
            });

            if (!data) {
                throw new Error('Leere Antwort vom Server');
            }

            if (!data.sdp) {
                if (data.id) {
                    callIdRef = data.id;
                    const accepted = await mw_open_ai_realtime_call_accept(data.id, {sdp: offer.sdp});
                    if (!accepted || !accepted.sdp) {
                        console.error('[Realtime] /accept lieferte keine SDP:', accepted);
                        return;
                    }
                    data = accepted;
                } else {
                    console.error('[Realtime] Unerwartete Antwort vom Server:', JSON.stringify(data));
                    return;
                }
            }

            // Remote Description setzen
            await pc.setRemoteDescription({type: 'answer', sdp: data.sdp});

            reset_text_and_show_old_placeholder(user_input_field);
            faqExamples.style.pointerEvents = 'all';
            user_input_field.focus();

            // Buttons umschalten
            main_ai_start_btn.disabled = true;
            main_ai_start_btn.classList.add('is-disabled');
        } catch (err) {
            console.error('[Realtime] Verbindungsfehler:', err);
            reset_text_and_show_old_placeholder(user_input_field);
        }
    }


    // ===== Record-Button (Push-to-Record) =====
    const recordBtn = document.querySelectorAll('.mw-ai-realtime-mute');

    // Funktion zum Aktualisieren aller Buttons
    function updateAllRecordButtons(recording) {
        recordBtn.forEach(function(btn) {
            if (recording) {
                btn.classList.add('is-recording');
                btn.classList.remove('is-muted');
                btn.setAttribute('data-state', 'recording');
            } else {
                btn.classList.remove('is-recording');
                btn.classList.add('is-muted');
                btn.setAttribute('data-state', 'idle');
            }
        });

        // Visualizer anzeigen/verstecken
        const visualizer = document.querySelector('.mw-audio-visualizer-wrapper');
        if (visualizer) {
            if (recording) {
                visualizer.classList.add('active');
            } else {
                visualizer.classList.remove('active');
            }
        }

        // Textarea State
        if (user_input_field) {
            if (recording) {
                user_input_field.classList.add('recording');
            } else {
                user_input_field.classList.remove('recording');
            }
        }
    }

    // Loading State während Transkription anzeigen/verstecken
    function setTranscriptionLoading(loading) {
        const loadingEl = document.querySelector('.mw-transcription-loading');
        if (loadingEl) {
            if (loading) {
                loadingEl.classList.add('active');
            } else {
                loadingEl.classList.remove('active');
            }
        }
    }

    // Initialisierung
    updateAllRecordButtons(false);

    // Event-Handler-Funktion (wird nur einmal definiert)
    async function handleRecordClick(e) {
        e.preventDefault();
        e.stopPropagation();

        console.log('[Realtime] Record button clicked, isRecording:', isRecording);

        // Prüfen ob PeerConnection bereit ist
        if (!pcRef || !dcRef || dcRef.readyState !== 'open') {
            console.warn('[Realtime] PeerConnection oder DataChannel nicht bereit');
            return;
        }

        // Falls Mikrofon noch nicht initialisiert, Berechtigung anfordern
        if (!micPermissionGranted && !micStreamRef) {
            try {
                const micStream = await navigator.mediaDevices.getUserMedia({
                    audio: {
                        echoCancellation: true,
                        noiseSuppression: true,
                        autoGainControl: true,
                        sampleRate: 24000, // OpenAI Realtime API bevorzugt 24kHz
                        channelCount: 1
                    },
                    video: false
                });
                micStreamRef = micStream;
                micPermissionGranted = true;
                console.log('[Realtime] Microphone stream initialized:', micStream.getAudioTracks()[0]?.getSettings());

                // Initial alle Tracks deaktivieren
                micStreamRef.getAudioTracks().forEach(track => {
                    track.enabled = false;
                });

                // AudioContext für Visualisierung erstellen
                if (!audioContext) {
                    audioContext = new (window.AudioContext || window.webkitAudioContext)();
                    const source = audioContext.createMediaStreamSource(micStream);
                    analyserNode = audioContext.createAnalyser();
                    analyserNode.fftSize = 2048;
                    source.connect(analyserNode);
                }

                // Track zum bestehenden Transceiver hinzufügen
                if (pcRef) {
                    const senders = pcRef.getSenders();
                    const audioSender = senders.find(s => s.track === null || s.track.kind === 'audio');

                    if (audioSender) {
                        const audioTrack = micStream.getAudioTracks()[0];
                        await audioSender.replaceTrack(audioTrack);
                    } else {
                        // Fallback: Track direkt hinzufügen falls kein Sender vorhanden
                        for (const track of micStream.getAudioTracks()) {
                            pcRef.addTrack(track, micStream);
                        }
                    }
                }
            } catch (err) {
                console.error('[Realtime] Fehler beim Zugriff auf Mikrofon:', err);
                alert('Mikrofon-Zugriff wurde verweigert oder ist nicht verfügbar.');
                return;
            }
        }

        // Toggle Recording
        isRecording = !isRecording;
        console.log('[Realtime] Recording toggled to:', isRecording);

        if (isRecording) {
            // Aufnahme starten
            console.log('[Realtime] Starting recording...');
            recordingStartTime = Date.now();
            user_input_field.value = ''; // Eingabefeld leeren
            hasSignificantAudio = false; // Reset
            audioLevelSamples = []; // Reset

            // Audio-Buffer leeren bevor wir starten (wichtig!)
            if (dcRef && dcRef.readyState === 'open') {
                try {
                    dcRef.send(JSON.stringify({
                        type: 'input_audio_buffer.clear'
                    }));
                    console.log('[Realtime] Audio buffer cleared before recording');
                } catch (err) {
                    console.error('[Realtime] Error clearing audio buffer:', err);
                }
            }

            // Mikrofon aktivieren
            if (micStreamRef) {
                console.log('[Realtime] Enabling microphone tracks...');
                micStreamRef.getAudioTracks().forEach(track => {
                    track.enabled = true;
                    console.log('[Realtime] Track enabled:', track.label, 'Settings:', track.getSettings());
                    console.log('[Realtime] Track constraints:', track.getConstraints());
                    console.log('[Realtime] Track muted:', track.muted, 'Ready state:', track.readyState);
                });

                // Test ob Audio-Daten ankommen
                if (audioContext && analyserNode) {
                    const testArray = new Uint8Array(analyserNode.frequencyBinCount);
                    analyserNode.getByteTimeDomainData(testArray);
                    const hasAudio = testArray.some(val => val !== 128);
                    console.log('[Realtime] Audio data detected:', hasAudio, 'Sample values:', testArray.slice(0, 10));
                }
            } else {
                console.warn('[Realtime] No micStreamRef available');
            }

            // Session-Konfiguration: Input Audio Transcription aktivieren, aber VAD (Voice Activity Detection) deaktivieren
            // Damit wird transkribiert, aber NICHT automatisch eine Response ausgelöst
            // GA-Schema: audio.input.turn_detection / audio.input.transcription, session.type = 'realtime'
            if (dcRef && dcRef.readyState === 'open') {
                try {
                    dcRef.send(JSON.stringify({
                        type: 'session.update',
                        session: {
                            type: 'realtime',
                            audio: {
                                input: {
                                    turn_detection: null, // VAD deaktivieren - verhindert automatische Responses
                                    transcription: {
                                        model: 'whisper-1',
                                        language: 'de' // Deutsch
                                    }
                                }
                            }
                        }
                    }));
                    console.log('[Realtime] VAD disabled, German language set for manual recording');
                } catch (err) {
                    console.error('[Realtime] Error updating session:', err);
                }
            }

            // Visualisierung starten
            console.log('[Realtime] Starting visualization...');
            startAudioVisualization();
        } else {
            // Aufnahme stoppen
            console.log('[Realtime] Stopping recording...');

            // Prüfen ob genug Audio aufgenommen wurde
            const recordingDuration = Date.now() - recordingStartTime;
            const minDuration = 600; // Mindestens 0.6 Sekunden

            // Zusätzliche Validierung: Wie viele Samples waren wirklich laut?
            const strongSamples = audioLevelSamples.filter(s => s.average > 40 || s.max > 80);
            const strongSampleRatio = audioLevelSamples.length > 0 ? strongSamples.length / audioLevelSamples.length : 0;

            console.log('[Realtime] Recording duration:', recordingDuration, 'ms');
            console.log('[Realtime] Has significant audio:', hasSignificantAudio);
            console.log('[Realtime] Audio samples:', audioLevelSamples.length);
            console.log('[Realtime] Strong samples:', strongSamples.length, '/', audioLevelSamples.length, '=', Math.round(strongSampleRatio * 100) + '%');

            // Flexible Validierung:
            // - Bei kurzen Aufnahmen (<2s): Mindestens 20% starke Samples
            // - Bei längeren Aufnahmen (≥2s): Mindestens 10% starke Samples (toleriert Pausen)
            const minStrongRatio = recordingDuration >= 2000 ? 0.10 : 0.20;
            const hasEnoughStrongAudio = strongSampleRatio >= minStrongRatio;

            console.log('[Realtime] Required strong ratio:', Math.round(minStrongRatio * 100) + '%', 'Actual:', Math.round(strongSampleRatio * 100) + '%');

            if (recordingDuration < minDuration || !hasSignificantAudio || !hasEnoughStrongAudio) {
                // Zu kurz oder kein Audio erkannt
                console.warn('[Realtime] Recording too short or no audio detected, not transcribing');
                // Pending-Submit abbrechen, da keine Transkription folgt
                pendingSubmitAfterTranscription = false;
                user_input_field.value = '';
                user_input_field.placeholder = 'Keine Sprache erkannt. Bitte lauter sprechen.';

                // Placeholder nach 3 Sekunden zurücksetzen
                setTimeout(() => {
                    user_input_field.placeholder = sessionStorage.getItem('ai_init_placeholder') || 'Nachricht eingeben...';
                }, 3000);

                // Audio-Buffer leeren ohne zu committen
                if (dcRef && dcRef.readyState === 'open') {
                    try {
                        dcRef.send(JSON.stringify({
                            type: 'input_audio_buffer.clear'
                        }));
                        console.log('[Realtime] Audio buffer cleared (no transcription)');
                    } catch (err) {
                        console.error('[Realtime] Error clearing audio buffer:', err);
                    }
                }
            } else {
                // Genug Audio vorhanden, transkribieren
                wasRecording = true; // Flag setzen für nachfolgende Transkriptions-Events

                // Loading-State anzeigen während Transkription läuft
                setTranscriptionLoading(true);

                // Audio Buffer committen, damit die Transkription finalisiert wird
                if (dcRef && dcRef.readyState === 'open') {
                    try {
                        dcRef.send(JSON.stringify({
                            type: 'input_audio_buffer.commit'
                        }));
                        console.log('[Realtime] Audio buffer committed');
                    } catch (err) {
                        console.error('[Realtime] Error committing audio buffer:', err);
                    }
                }
            }

            if (micStreamRef) {
                console.log('[Realtime] Disabling microphone tracks...');
                micStreamRef.getAudioTracks().forEach(track => {
                    track.enabled = false;
                    console.log('[Realtime] Track disabled:', track.label);
                });
            }

            // Visualisierung stoppen
            stopAudioVisualization();

            // Text im Eingabefeld lassen, damit User ihn bearbeiten kann
            // Der transkribierte Text sollte bereits im Eingabefeld stehen
            user_input_field.focus();

            // wasRecording wird zurückgesetzt wenn die Transkription abgeschlossen ist
            // (siehe isUserTranscriptDone Handler)
        }

        // ALLE Buttons aktualisieren
        console.log('[Realtime] Updating buttons with isRecording:', isRecording);
        updateAllRecordButtons(isRecording);
    }

    // Event-Listener nur einmal pro Button hinzufügen
    console.log('[Realtime] Recording buttons found:', recordBtn.length);
    recordBtn.forEach(function(record_btn) {
        console.log('[Realtime] Adding click listener to button:', record_btn);
        record_btn.addEventListener('click', handleRecordClick);
    });

    const speakerBtn = document.querySelectorAll('.mw-ai-realtime-speaker');

    function updateAllSpeakerButtons(enabled) {
        speakerBtn.forEach(function(btn) {
            if (enabled) {
                btn.classList.remove('is-disabled');
                btn.setAttribute('data-state', 'enabled');
            } else {
                btn.classList.add('is-disabled');
                btn.setAttribute('data-state', 'disabled');
            }
        });
    }

    // Initialisierung
    updateAllSpeakerButtons(isAudioEnabled);

    // Event-Handler-Funktion (wird nur einmal definiert)
    function handleSpeakerClick(e) {
        e.preventDefault();
        e.stopPropagation();

        isAudioEnabled = !isAudioEnabled;

        // Status in sessionStorage speichern
        sessionStorage.setItem('mw_ai_audio_enabled', isAudioEnabled.toString());

        // ALLE Buttons aktualisieren
        updateAllSpeakerButtons(isAudioEnabled);

        // Audio-Element stummschalten oder aktivieren
        if (remoteAudioEl) {
            remoteAudioEl.muted = !isAudioEnabled;
        }

    }

    // Event-Listener nur einmal pro Button hinzufügen
    speakerBtn.forEach(function(speaker_btn) {
        speaker_btn.addEventListener('click', handleSpeakerClick);
    });

    // ===== Clear-Button (Chat-Verlauf löschen) =====
    const clearBtn = document.querySelector('.mw-ai-clear-btn');
    if (clearBtn) {
        clearBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Local Storage löschen
            if (isHistoryEnabled) {
                localStorage.removeItem(CHAT_HISTORY_KEY);
            }

            // Chat-Fenster leeren
            if (chatWindow) {
                chatWindow.innerHTML = '';
            }

            // Chat-Status zurücksetzen
            chatStarted = false;
            currentAssistantMessage = '';
            assistantStreamBubble = null;
            userStreamBubble = null;

            // Intro und FAQ wieder anzeigen
            const introWrapper = document.querySelector('.mw-ai-realtime-intro-wrapper');
            const innerWrapper = document.querySelector('.mw-ai-realtime-inner-wrapper');
            if (introWrapper) {
                introWrapper.style.display = '';
            }
            if (faqExamples) {
                faqExamples.style.display = '';
            }
            if (innerWrapper) {
                innerWrapper.style.gridTemplateRows = '';
            }
        });
    }

    if (modal_close_btn) {
        modal_close_btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Session beenden
            // endSession();

            isAudioEnabled = false;
            isRecording = false;

            // Status in sessionStorage speichern
            sessionStorage.setItem('mw_ai_audio_enabled', 'false');

            updateAllSpeakerButtons(false);
            updateAllRecordButtons(false);
            stopAudioVisualization();

            remoteAudioEl.muted = true;
            if (micStreamRef) {
                micStreamRef.getAudioTracks().forEach(track => {
                    track.enabled = false;
                });
            }

            modal_close_btn.closest('dialog').close();

        })
    }

    // Reconnect wenn Seite nach Handy-Sperre wieder sichtbar wird
    document.addEventListener('visibilitychange', function () {
        if (document.hidden) return;
        if (!isSessionActive) return;

        const dcDead = !dcRef || dcRef.readyState === 'closed' || dcRef.readyState === 'closing';
        const pcDead = !pcRef || pcRef.connectionState === 'closed' || pcRef.connectionState === 'failed' || pcRef.connectionState === 'disconnected';

        if (dcDead || pcDead) {
            console.log('[Realtime] Verbindung nach Hintergrund verloren – Reconnect...');
            isSessionActive = false;
            isConnectionReady = false;
            dcRef = null;
            pcRef = null;
            start_gpt_connect();
            isSessionActive = true;
        }
    });

    // Session beenden beim Verlassen der Seite (mit keepalive)
    window.addEventListener('beforeunload', function() {
        sessionStorage.removeItem('mw_realtime_session_ready');
        if (sessionId) {
            fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/realtime/session/end', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': mwRealtimeAiConfig.nonce
                },
                body: JSON.stringify({ session_id: sessionId }),
                keepalive: true
            }).catch(() => {});
        }
    });

    // Session auch beenden, wenn Dialog geschlossen wird
    // if (dialog) {
    //     dialog.addEventListener('close', function() {
    //         endSession();
    //     });
    // }

});

function open_ai_dialog( dialog ) {
    // Zunächst Consent Checks machen.
    if ( window.CCM ) {
        let user_is_okay_with_ki_use = false;
        const ki_cookie_name = 'ChatGPT / OpenAI API';
        window.CCM.acceptedEmbeddings.forEach(item => {
            if (ki_cookie_name === item.name) {
                user_is_okay_with_ki_use = true;
            }
        });
        if ( true === user_is_okay_with_ki_use ) {
            dialog.show();
        } else {
            window.CCM.openWidget();
        }
    } else {
        // Enfold unterstützen.
        if (true === mw_check_cookie_by_name_ki('aviaCookieConsent') && false === mw_check_cookie_by_name_ki('aviaPrivacyCustomCookiemw_ki_cookieDisabled')) {
            dialog.show();
        } else {
            if ( document.querySelector('.avia-cookie-info-btn') ) {
                document.querySelector('.avia-cookie-info-btn').click();
            }
        }
    }
}

function mw_check_cookie_by_name_ki(cookie_name = '') {
    if ('' !== cookie_name) {
        var name = cookie_name + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var cookie_list = decodedCookie.split(';');
        var len = cookie_list.length;
        for (var i = 0; i < len; i++) {
            var current_cookie = cookie_list[i];
            while (current_cookie.charAt(0) === ' ') {
                current_cookie = current_cookie.substring(1);
            }
            if (current_cookie.indexOf(name) === 0) {
                return true;
            }
        }
    }
    return false;
}

// ===== API-Funktionen =====
async function mw_open_ai_realtime_call_init(given_data) {
    const res = await fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/calls', {
        method: 'POST', headers: {
            'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce
        }, body: JSON.stringify(given_data)
    });

    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/sdp')) {
        const sdpText = await res.text();
        return {sdp: sdpText};
    }

    const json = await res.json().catch(() => null);
    if (json) return json;

    const text = await res.text().catch(() => '');
    if (text && /^v=0/m.test(text)) {
        return {sdp: text};
    }

    return null;
}

async function mw_open_ai_realtime_call_accept(call_id, given_data) {
    const res = await fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/calls/' + encodeURIComponent(call_id) + '/accept', {
        method: 'POST', headers: {
            'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce
        }, body: JSON.stringify(given_data)
    });

    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/sdp')) {
        const sdpText = await res.text();
        return {sdp: sdpText};
    }

    const json = await res.json().catch(() => null);
    if (json) return json;

    const text = await res.text().catch(() => '');
    if (text && /^v=0/m.test(text)) {
        return {sdp: text};
    }

    return null;
}

async function mw_open_ai_realtime_call_hangup(call_id) {
    const res = await fetch(mwRealtimeAiConfig.rest + 'immowerft/v2/openai/realtime/calls/' + encodeURIComponent(call_id) + '/hangup', {
        method: 'POST', headers: {
            'Content-Type': 'application/json', 'X-WP-Nonce': mwRealtimeAiConfig.nonce
        }
    });

    if (res.status === 204) {
        return {ok: true};
    }

    const json = await res.json().catch(() => null);
    return json || {ok: res.ok};
}
